import { FormControl } from "@angular/forms";

export function parseCurrency(s: string): number {
  return parseFloat(s.replace(/,/g, ''));
}

export default function currencyFormatter(fc: FormControl): FormControl {
  const formatted = format(fc.value);
  fc.setValue(formatted, { emitEvent: false });
  fc.valueChanges.subscribe(value => {
    const f = format(value);
    fc.setValue(f, { emitEvent: false });
  });
  return fc;
}

function format(value: any): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  const numericValue = value.toString().replace(/,/g, '').trim();
  if (numericValue !== '' && !isNaN(Number(numericValue))) {
    return parseFloat(numericValue).toLocaleString('en-US', { minimumFractionDigits: 0 });
  }
  return value;
}
